// extracted by mini-css-extract-plugin
export var createdDate = "_mk-1";
export var divider = "_mk-2";
export var headerDivider = "_mk-3";
export var messagesCard = "_mk-0";
export var messagesContainer = "_mk-6";
export var messagesContainerWrapper = "_mk-4";
export var showLeftPanelButton = "_mk-8";
export var topButtons = "_mk-7";
export var withPadding = "_mk-5";